function createCaptcha(wrapper) {
  const captchaWrapper = document.getElementById(wrapper);

  if (captchaWrapper === null) {
    return;
  }
  // clear the contents of captcha div first
  captchaWrapper.innerHTML = "";

  const charsArray = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ@!#$%^&*";
  const lengthOtp = 6;
  const captcha = [];

  for (let i = 0; i < lengthOtp; i++) {
    //below code will not allow Repetition of Characters
    let index = Math.floor(Math.random() * charsArray.length + 1); //get the next character from the array

    if (captcha.indexOf(charsArray[index]) === -1)
      captcha.push(charsArray[index]);
    else i--;
  }

  let canvas = document.createElement("canvas");

  canvas.id = "captchaCanvas";

  let ctx = canvas.getContext("2d");

  ctx.font = "4.5rem Arial";
  var my_gradient = ctx.createLinearGradient(0, 0, 0, 170);
  my_gradient.addColorStop(0, "#F1511B");
  my_gradient.addColorStop(1, "white");
  ctx.fillStyle = my_gradient;
  // ctx.fillStyle = '#F1511B';
  // ctx.strokeStyle = '#009900';
 
  ctx.fillText(captcha.join(""), 20, 80);
  //storing captcha so that can validate you can save it somewhere else according to your specific requirements

  captchaWrapper.appendChild(canvas); // adds the canvas to the body element

  return captcha.join("");
}

export default {
  init() {
    let code = createCaptcha('captcha');

    const $form = jQuery('.registration-form');

    $form.on('submit', function (evt) {
      evt.preventDefault();
      evt.stopPropagation();

      if ($form.find('[name="captcha"]').val() !== code) {
        code = createCaptcha('captcha');
        $form.find('[name="captcha"]').val("");

        return;
      }


      const data = {
        action: 'register',
        event: $form.find('[name="event"]').val(),
        date: $form.find('[name="date"]').val(),
        month: $form.find('[name="month"]').val(),
        location: $form.find('[name="location"]').val(),
        company: $form.find('[name="company"]').val(),
        lastName: $form.find('[name="lasName"]').val(),
        firstName: $form.find('[name="firstName"]').val(),
        function: $form.find('[name="function"]').val(),
        address: $form.find('[name="address"]').val(),
        zipCode: $form.find('[name="zipCode"]').val(),
        phone: $form.find('[name="phone"]').val(),
        mobile: $form.find('[name="mobile"]').val(),
        email: $form.find('[name="email"]').val(),
        order: $form.find('[name="order"]').val(),
        billing: $form.find('[name="billing"]').val(),
      };

      jQuery('#loader').show();

      jQuery.ajax({
        type: 'POST',
        url: `//${window.location.hostname}/wp/wp-admin/admin-ajax.php`,
        dataType: 'html',
        data,
        success: function () {
          jQuery('#loader').hide();
        },
        error: function () {
          jQuery('#loader').hide();
        },
      });
    });
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/seminar.js